import { useQuery } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { queryKeys } from './queryKeys';
import { AssetBucketingDTO } from './useAssetBucketQuery';

const fetchAssetBucket = (): Promise<AssetBucketingDTO> =>
  authFetch('/Adviser/AssetBucketing/AdviserLayout');

export const useAdvisorAssetBucketQuery = (enabled = false) => {
  return useQuery(queryKeys.advisorAssetBucket(), () => fetchAssetBucket(), {
    cacheTime: 0,
    enabled,
  });
};
